import { useReducer, useEffect, useRef } from 'react';

export const ON_FETCH = 'ON_FETCH';
export const ON_ERROR = 'ON_ERROR';

function reducer(state, action) {
  switch (action.type) {
    case ON_FETCH:
      return {
        ...state,
        data: {
          id: action.snapshot.id,
          ...action.snapshot.data(),
        },
        loading: false,
      };
    case ON_ERROR:
      return {
        ...state,
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

const initialState = {
  data: null,
  loading: true,
  err: null,
};

export const useDocument = (query, deps) => {
  
  const [state, dispatch] = useReducer(reducer, initialState);
  const ref = useRef(query);

  const { data, loading, err } = state;

  useEffect(() => {
    if (!ref.current) return;
    let isCancelled = false;
    (async function fetchData() {
      try {
        const snapshot = await ref.current.get();
        if (snapshot.empty) {
          return dispatch({
            type: ON_ERROR,
            payload: { error: 'Document is empty' },
          });
        }
        if (!isCancelled) {
          dispatch({ type: ON_FETCH, snapshot });
        }
      } catch (err) {
        dispatch({ type: ON_ERROR, error: err.message });
      }
    })(); 
    return () => (isCancelled = true);
  }, [deps]);

  return [data, loading, err];
};
